import React, { Component } from 'react'
import {Switch, Route, Redirect, NavLink} from "react-router-dom";
import Edit from "./Edit";
import Summary from "./Summary";
import Participiants from "./Participiants";

class Details extends Component {
    render () {
        return (
            <div className="panel panel-default panel-border">
                <div className="panel-body">

                    <ul className="nav nav-tabs" style={{marginBottom: 40}}>
                        <li role="presentation" className={this.props.location.pathname === "/backoffice/waiting-lists/" + this.props.match.params.id + "/summary" ? 'active' : null}>
                            <NavLink to={"/backoffice/waiting-lists/" + this.props.match.params.id + "/summary"}>
                                Riepilogo
                            </NavLink>
                        </li>
                        <li role="presentation" className={this.props.location.pathname === "/backoffice/waiting-lists/" + this.props.match.params.id + "/participiants" ? 'active' : null}>
                            <NavLink  to={"/backoffice/waiting-lists/" + this.props.match.params.id + "/participiants"}>
                                Partecipanti
                            </NavLink>
                        </li>
                        <li role="presentation" className={this.props.location.pathname === "/backoffice/waiting-lists/" + this.props.match.params.id + "/edit" ? 'active' : null}>
                            <NavLink  to={"/backoffice/waiting-lists/" + this.props.match.params.id + "/edit"}>
                                Impostazioni
                            </NavLink>
                        </li>
                    </ul>
                    <Switch>
                        <Route path="/backoffice/waiting-lists/:id/summary" component={Summary} />
                        <Route path="/backoffice/waiting-lists/:id/edit" component={Edit} />
                        <Route path="/backoffice/waiting-lists/:id/participiants" component={Participiants} />
                        <Redirect to={"/backoffice/waiting-lists/" + this.props.match.params.id + "/summary"} />
                    </Switch>
                </div>
            </div>
        )
    }
}

export default Details



// WEBPACK FOOTER //
// ./src/containers/Backoffice/BackofficeWaitingList/Details/Details.js